export function sessionStorageGet(key: string) {
  const item = sessionStorage.getItem(key);
  if (item !== 'undefined' && item) {
    try {
      return JSON.parse(item);
    } catch {
      // Value isn't JSON (e.g. a raw token, or a stale/hand-set value). Return it as-is
      // rather than throwing an uncaught error that surfaces React's red dev overlay.
      return item;
    }
  }
}

export function sessionStorageSet(key: string, item: any) {
  sessionStorage.setItem(key, JSON.stringify(item));
}
